import { PromiseCompletionSource } from "scene-manager";
import { BaseView } from "scene-manager";
import { Graphics, IDestroyOptions, Sprite, Text, TextStyle, Texture } from "pixi.js";
import { ICanvasScaler } from "../../../../../canvas/ICanvasScaler";

export class AdView extends BaseView<boolean> {
    private root: Graphics;
    private timerCountdown: number = 2;
    private countdownText: Text;
    public constructor(private readonly canvasScaler: ICanvasScaler, pcs: PromiseCompletionSource<boolean>) {
        super(pcs);
        this.eventMode = "static";
        this.build();
        this.layout();
        this.canvasScaler.onResize.add(this.layout, this);
    }

    private build(): void {
        this.root = this.addChild(new Graphics());
        this.root.beginFill(0xffffff, 1);
        this.root.drawRect(0, 0, this.canvasScaler.browserWidth, this.canvasScaler.browserHeight);
        this.root.endFill();
        this.root.eventMode = "static";
        this.root.cursor = "hover";

        this.countdownText = this.addChild(new Text(this.timerCountdown, this.countdownTextStyle));
        this.countdownText.anchor.set(0.5);
    }

    private layout(): void {
        const scale = this.canvasScaler.getSize().height / this.canvasScaler.browserHeight;
        this.root.width = this.canvasScaler.browserWidth * scale;
        this.root.height = this.canvasScaler.browserHeight * scale;
        this.root.position.x = (this.canvasScaler.referenceWidth - this.root.width) * 0.5;
        this.countdownText.position.set(this.canvasScaler.referenceWidth * 0.5, this.canvasScaler.referenceHeight * 0.5);
    }

    public override async start(): Promise<void> {
        await this.countdown();
    }

    private async countdown(): Promise<void> {
        await this.sleep();
        this.timerCountdown--;
        this.countdownText.text = this.timerCountdown;
        await this.sleep();
        this.timerCountdown--;
        this.countdownText.text = this.timerCountdown;
        this.operationControls.complete(true);
    }

    private sleep(): Promise<void> {
        // this uses only for demo
        return new Promise(resolve => setTimeout(resolve, 1000));
    }

    private get countdownTextStyle(): TextStyle {
        return new TextStyle({
            fontFamily: "Lato Black",
            align: "center",
            fill: "#000000",
            fontSize: 240
        });
    }

    public override destroy(options?: IDestroyOptions | boolean): void {
        this.canvasScaler.onResize.remove(this.layout, this);
        super.destroy(options);
    }
}